export const currency = (value, locale = "es-mx", currency = "MXN") => {
  return Intl.NumberFormat(locale, {
    currency,
    style: "currency",
  }).format(value);
};
